"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KvStore = void 0;
exports.KvStore = {
    name: "kvStore",
    async info() {
        // @ts-ignore
        return await this.call("kvstore.info");
    },
    async get(symbols) {
        // @ts-ignore
        throw new Error("Not implemented");
    },
    async put() {
        throw new Error("Not implemented");
    },
    async delete() {
        throw new Error("Not implemented");
    },
};
